import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  DASHBOARD_APPROVAL_ACL,
  RNC,
  RNCAPPROVED,
  RNCREJECTED,
  SALES,
  STATUS_CODE_200,
  SUCCESS,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";

function BankDetails({ clientData, isEditClicked, onChange, role, status }) {
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [nameAsbank, setNameasBank] = useState("");
  const [bankIfscCode, setBankIfscCode] = useState("");
  const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
  const [remitterBankName, setRemitterBankName] = useState("");
  const [remitterIfscCode, setRemitterIfscCode] = useState("");
  const [payin, setPayin] = useState({});
  const [payout, setPayout] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState();
  const [ifscValidate, setIfscValidate] = useState(false);
  const [ifscLoadingRemitter, setIfscLoadingRemitter] = useState(false);
  const [ifscLoading, setIfscLoading] = useState(false);
  const [ifscRemitterValidate, setIfscRemitterValidate] = useState(false);
  const [settlementAccountValidate, setSettlementAccountValidate] =
    useState(false);
  const [remitterAccountValidate, setRemitterAccountValidate] = useState(false);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [debitorAccount, setDebitorAccount] = useState([]);
  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    maxWidth: 500,
    minWidth: 250,
    width: 350,
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  const debitorAccKeys = {
    corpid: "Corporate Id",
    userid: "User Id",
    debitorAccNumber: "Debitor Account Number",
    debitorAccIfsc: "Debitor IFSC CODE",
    revenueAccNumber: "Revenue Account Number",
    revenueAccIfsc: "Revenue Account IFSC",
  };

  const validateAccountWithPennyDrop = (
    accNo,
    ifsc,
    benificiaryName,
    settlement = false
  ) => {
    const accNoRegex = /^[0-9]{9,18}$/;
    const ifscRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;

    if (!accNo && !ifsc && !benificiaryName) {
      enqueueSnackbar("Please enter all the account details", {
        variant: "error",
      });
      return;
    }

    if (!accNoRegex.test(accNo)) {
      enqueueSnackbar("Please enter valid account number", {
        variant: "error",
      });
      return;
    }

    if (!ifscRegex.test(ifsc)) {
      enqueueSnackbar("Please enter valid ifsc code", {
        variant: "error",
      });
      return;
    }

    setLoading(true);
    ApiRequestPost.checkPennyDropAccount({
      accNo,
      ifsc,
      benificiaryName,
      address: clientData?.address,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          if (res?.data?.status === SUCCESS) {
            if (settlement) {
              setSettlementAccountValidate(true);
            } else {
              setIfscLoading(false);
              setIfscLoadingRemitter(false);
              setRemitterAccountValidate(true);
            }
            enqueueSnackbar("Account verified successfully", {
              variant: "success",
            });
          } else {
            let errorMessgae = "Account verification failed";

            if (res?.data?.desc && res?.data?.recommendedAction) {
              errorMessgae =
                res?.data?.desc + ":" + res?.data?.recommendedAction;
            } else if (res?.data?.desc) {
              errorMessgae = res?.data?.desc;
            }
            enqueueSnackbar(errorMessgae, {
              variant: "error",
            });
          }
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((e) => {
        console.log("Error", e);
      })
      .finally(() => {
        setIfscLoading(false);
        setIfscLoadingRemitter(false);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (!isEditClicked) {
      setNameasBank(clientData?.nameAsPerBank);
      setBankAccountNumber(clientData?.bankAccountNumber);
      setBankIfscCode(clientData?.bankIfscCode);
      setRemitterBankName(clientData?.remitterNameAsPerBank);
      setRemitterAccountNumber(clientData?.remitterAccountNumber);
      setRemitterIfscCode(clientData?.remitterIfscCode);
    }
  }, [isEditClicked, clientData]);

  useEffect(() => {}, [isEditClicked, clientData]);

  useEffect(() => {
    onChange({
      bankAccountNumber: custom_getvalue(
        bankAccountNumber,
        clientData?.bankAccountNumber
      ),
      nameAsPerBank: custom_getvalue(nameAsbank, clientData?.nameAsPerBank),
      bankIfscCode: custom_getvalue(bankIfscCode, clientData?.bankIfscCode),
      remitterAccountNumber: custom_getvalue(
        remitterAccountNumber,
        clientData?.remitterAccountNumber
      ),
      remitterNameAsPerBank: custom_getvalue(
        remitterBankName,
        clientData?.remitterNameAsPerBank
      ),
      remitterIfscCode: custom_getvalue(
        remitterIfscCode,
        clientData?.remitterIfscCode
      ),
    });
  }, [
    bankAccountNumber,
    nameAsbank,
    bankIfscCode,
    remitterAccountNumber,
    remitterBankName,
    remitterIfscCode,
  ]);

  useEffect(() => {
    setPayout(clientData?.service.find((e) => e.serviceType === "payout"));
    setPayin(
      clientData?.service.find(
        (e) =>
          e.serviceType === "payin" ||
          e.serviceType === "van" ||
          e.serviceType === "voucher" ||
          e.serviceType === "van-upi"
      )
    );
  }, [clientData]);

  useEffect(() => {
    const payoutPrograms = clientData?.programs?.find(
      (item) =>
        ["cba", "van", "vba"].includes(item?.mechanism) ||
        item?.serviceProviderName.toUpperCase() === "AXIS" ||
        item?.serviceProviderName.toUpperCase() === "Zyro" ||
        item?.serviceProviderName.toUpperCase() === "Eskay" ||
        (item?.serviceProviderName.toUpperCase() === "Equitas" &&
          item?.service_type === "payout")
    );
    let temp = [];

    temp.push(payoutPrograms);
    setDebitorAccount([...temp]);
  }, [clientData]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "20px",
        }}
      >
        {debitorAccount &&
        debitorAccount[0] &&
        debitorAccount[0]?.remitterAcc ? (
          <div style={{ width: "50%", minWidth: "400px" }}>
            <p>Remitter Account</p>
            <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Name as per Bank
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={remitterBankName}
                onChange={(data) => {
                  if (!isEditClicked) {
                    setRemitterBankName(clientData?.remitterBankName);
                  } else {
                    setRemitterBankName(data);
                  }
                }}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Name as per Bank "
                validator="businessName"
                type="input"
                maxLength={50}
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
              <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                Account Number
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={remitterAccountNumber}
                onChange={(data) => {
                  if (!isEditClicked) {
                    setRemitterAccountNumber(clientData?.remitterAccountNumber);
                  } else {
                    setRemitterAccountNumber(data);
                  }
                }}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Account Number"
                validator="accountNumber"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>

            <div
              style={{
                marginTop: 20,
                width: "100%",
                minWidth: "500px",
                display: "flex",
              }}
            >
              <div>
                <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                  IFSC
                </label>
                <div style={{ display: "flex", gap: "5%" }}>
                  <CustomInput
                    disabled={isEditClicked ? "" : "disabled"}
                    value={remitterIfscCode}
                    onChange={(data) => {
                      if (!isEditClicked) {
                        setRemitterIfscCode(clientData?.remitterAccountNumber);
                      } else {
                        setRemitterIfscCode(data);
                      }
                    }}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Enter IFSC"
                    validator="ifscCode"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
              </div>

              <div style={{ alignSelf: "end" }}>
                {role === RNC &&
                  status !== RNCREJECTED &&
                  status !== RNCAPPROVED && (
                    <>
                      {ifscLoadingRemitter ? (
                        <div
                          style={{
                            // marginTop: "5px",
                            // marginLeft: "10px",
                            paddingLeft: 10,
                            paddingBottom: 10,
                          }}
                        >
                          <CustomLoader />
                        </div>
                      ) : (
                        <CustomButton
                          title={ifscRemitterValidate ? "Verified" : "Validate"}
                          onClick={() => {
                            setIfscLoadingRemitter(true);
                            if (!ifscRemitterValidate) {
                              validateAccountWithPennyDrop(
                                remitterAccountNumber,
                                remitterIfscCode,
                                remitterBankName
                              );
                            }
                          }}
                          styles={{
                            alignSelf: "flex-end",
                            marginLeft: "7px",
                          }}
                        />
                      )}
                    </>
                  )}
              </div>
            </div>
          </div>
        ) : !payin &&
          debitorAccount[0] &&
          debitorAccount[0]?.serviceProviderName.toUpperCase() !== "ZYRO" &&
          debitorAccount[0]?.serviceProviderName.toUpperCase() !== "EQUITAS" ? (
          <div style={{ width: "50%", minWidth: "400px" }}>
            <p>Remitter Account</p>
            <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Name as per Bank
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={remitterBankName}
                onChange={(data) => {
                  if (!isEditClicked) {
                    setRemitterBankName(clientData?.remitterBankName);
                  } else {
                    setRemitterBankName(data);
                  }
                }}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Name as per Bank "
                validator="businessName"
                type="input"
                maxLength={50}
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
              <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                Account Number
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={remitterAccountNumber}
                onChange={(data) => {
                  if (!isEditClicked) {
                    setRemitterAccountNumber(clientData?.remitterAccountNumber);
                  } else {
                    setRemitterAccountNumber(data);
                  }
                }}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Account Number"
                validator="accountNumber"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>

            <div
              style={{
                marginTop: 20,
                width: "100%",
                minWidth: "500px",
                display: "flex",
              }}
            >
              <div>
                <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                  IFSC
                </label>
                <div style={{ display: "flex", gap: "5%" }}>
                  <CustomInput
                    disabled={isEditClicked ? "" : "disabled"}
                    value={remitterIfscCode}
                    onChange={(data) => {
                      if (!isEditClicked) {
                        setRemitterIfscCode(clientData?.remitterAccountNumber);
                      } else {
                        setRemitterIfscCode(data);
                      }
                    }}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Enter IFSC"
                    validator="ifscCode"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
              </div>

              <div style={{ alignSelf: "end" }}>
                {role === RNC &&
                  status !== RNCREJECTED &&
                  status !== RNCAPPROVED && (
                    <>
                      {ifscLoadingRemitter ? (
                        <div
                          style={{
                            // marginTop: "5px",
                            // marginLeft: "10px",
                            paddingLeft: 10,
                            paddingBottom: 10,
                          }}
                        >
                          <CustomLoader />
                        </div>
                      ) : (
                        <CustomButton
                          title={ifscRemitterValidate ? "Verified" : "Validate"}
                          onClick={() => {
                            setIfscLoadingRemitter(true);
                            if (!ifscRemitterValidate) {
                              validateAccountWithPennyDrop(
                                remitterAccountNumber,
                                remitterIfscCode,
                                remitterBankName
                              );
                            }
                          }}
                          styles={{
                            alignSelf: "flex-end",
                            marginLeft: "7px",
                          }}
                        />
                      )}
                    </>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {payout && (
          <>
            <div style={{ width: "50%", minWidth: "400px" }}>
              {debitorAccount?.length > 0 &&
                debitorAccount.map((item, index) =>
                  item?.mechanism === "cba" ||
                  item?.mechanism === "van" ||
                  (item?.mechanism === "vba" &&
                    item?.serviceProviderName.toUpperCase() === "EQUITAS") ||
                  ((item?.mechanism === "vba" || item?.mechanism === "van") &&
                    item?.serviceProviderName === "Zyro") ? (
                    <div
                      style={{ lineHeight: "2em", marginTop: "0" }}
                      key={index}
                    >
                      <div
                        style={{
                          color: "#000",
                          textAlign: "center",
                          marginBottom: 0,
                          textAlignLast: "left",
                        }}
                      >
                        {item?.serviceProviderName} Debitor Account
                      </div>

                      {Object.entries(item?.debitorAcc[0]).map(
                        ([key, value], index) => {
                          if (key !== "_id" && key !== "status" && value) {
                            const customKeyName = debitorAccKeys[key] || key;
                            return (
                              <>
                                <label style={{ fontSize: 14, lineHeight: 1 }}>
                                  {customKeyName}
                                </label>
                                <CustomInput
                                  key={index}
                                  value={value}
                                  inputcomponentStyles={{ ...inputStyle }}
                                  type="input"
                                  inputStyles={{
                                    ...containerStyle,
                                  }}
                                />
                              </>
                            );
                          }
                        }
                      )}

                      {item.revenueAcc?.length > 0 && (
                        <div>
                          {Object.entries(item?.revenueAcc[0]).map(
                            ([key, value], index) => {
                              if (key !== "_id" && key !== "status" && value) {
                                const customKeyName =
                                  key === "revenueAccNumber"
                                    ? "Revenue Account Number"
                                    : key === "revenueAccIfsc"
                                    ? "Revenue Account IFSC"
                                    : "";

                                return (
                                  <>
                                    <label
                                      style={{ fontSize: 14, lineHeight: 2 }}
                                    >
                                      {customKeyName}
                                    </label>
                                    <CustomInput
                                      key={index}
                                      value={value}
                                      inputcomponentStyles={{ ...inputStyle }}
                                      type="input"
                                      inputStyles={{
                                        ...containerStyle,
                                      }}
                                    />
                                  </>
                                );
                              }
                            }
                          )}
                        </div>
                      )}
                    </div>
                  ) : null
                )}
            </div>
          </>
        )}
        <>
          {payin && (
            <div style={{ width: "50%", minWidth: "400px", marginTop: "10px" }}>
              <p>Settlement Account</p>
              <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Name as per Bank
                </label>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={nameAsbank}
                  onChange={(data) => {
                    if (!isEditClicked) {
                      setNameasBank(clientData?.nameAsPerBank);
                    } else {
                      setNameasBank(data);
                    }
                  }}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Name as per Bank "
                  validator="businessName"
                  maxLength={50}
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
              <div style={{ marginTop: 20, width: "100%", minWidth: "500px" }}>
                <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                  Account Number
                </label>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={bankAccountNumber}
                  onChange={(data) => {
                    if (!isEditClicked) {
                      setBankAccountNumber(clientData?.bankAccountNumber);
                    } else {
                      setBankAccountNumber(data);
                    }
                  }}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Account Number"
                  validator="accountNumber"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  minWidth: "500px",
                  display: "flex",
                }}
              >
                <div>
                  <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
                    Enter IFSC
                  </label>
                  <div style={{ display: "flex" }}>
                    <CustomInput
                      disabled={isEditClicked ? "" : "disabled"}
                      value={bankIfscCode}
                      onChange={(data) => {
                        if (!isEditClicked) {
                          setBankIfscCode(clientData?.bankIfscCode);
                        } else {
                          setBankIfscCode(data);
                        }
                      }}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Enter IFSC"
                      validator="ifscCode"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                </div>

                {role === RNC &&
                  status !== RNCREJECTED &&
                  status !== RNCAPPROVED && (
                    <>
                      {ifscLoading ? (
                        <div
                          style={{
                            // marginTop: "5px",
                            // marginLeft: "10px",
                            paddingLeft: 10,
                            paddingTop: 40,
                          }}
                        >
                          <CustomLoader />
                        </div>
                      ) : (
                        <CustomButton
                          title={ifscValidate ? "Verified" : "Validate"}
                          onClick={() => {
                            setIfscLoading(true);
                            if (!ifscValidate) {
                              validateAccountWithPennyDrop(
                                bankAccountNumber,
                                bankIfscCode,
                                nameAsbank
                              );
                            }
                          }}
                          styles={{ alignSelf: "flex-end", marginLeft: "7px" }}
                        />
                      )}
                    </>
                  )}
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
}

export default BankDetails;
